import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from 'root/RootLayout';

export const accessDeniedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'access-denied',
  component: lazyRouteComponent(() => import('./AccessDeniedView')),
});
